import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'deliveryuserlogout',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
    Multiselect
  },
  props: [],
  mixins:[PageTracker],
  data: function() {
    return {
      listUserData: [],
      currentHub:[],
      userid:'',
      srListLoader: false,
      comment:'',
      errComment: false,
      hubid:'',
      listHubData:[],
      hubListLoader:false,
      selectedHubObj:'',
      selectedUserObj:'',
      userDataKey : '',
    }
  },
  computed: {

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub.push(userdetail.hubdetails[0]);
    var hubListEncrypt = window.localStorage.getItem('hubaccesslist')
    var bytesHubList = CryptoJS.AES.decrypt(hubListEncrypt.toString(), this.userDataKey);
    var plaintextHubList = bytesHubList.toString(CryptoJS.enc.Utf8);
    this.listHubData = JSON.parse(plaintextHubList);
  },
  methods: {
    afterTypeSelected(obj){
      this.hubid = obj.value
      this.selectedHubObj = obj;
      this.getSRUserList(this.hubid);
    },
    afterUserSelected(obj){
      this.userid = obj.value;
      this.selectedUserObj = obj;
    },
    customLabel ({ FirstName}) {
      return `${FirstName}`
    },
    //to get hub sr user list to force logout
    getSRUserList(hubid) {
      this.srListLoader = true;
      this.input = ({
        HubID: hubid
      });
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'DayEndClosure/getHubWiseSrList',
          'data': this.input,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(result => {
           let userdata = result.data.data;
           if(userdata && userdata.length > 0){
            this.srListLoader = false;
            for (var i = 0; i < userdata.length; i++) {
              console.log(userdata[i].deliveryusername);
              this.listUserData.push({
                value: userdata[i].dayendclosermasterid,
                text: userdata[i].deliveryusername
              })
            }
          }else{
            this.listUserData = [];
            this.srListLoader = false;
          }
        },error => {
          console.error(error)
          this.listUserData = [];
          this.srListLoader = false;
        })
    },
    enabledAllocation(event){
      var userToken = window.localStorage.getItem('lmaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      let unblockuserids = [];
      if(this.userid.length>0){
        this.userid.forEach(user => {
          unblockuserids.push(user.value);
        });
      }
      
      this.input = ({
        DayEndClosureMasterID: unblockuserids,
        Comments: this.comment,
        UnblockedBy: this.useremail
      });
      
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'DayEndClosure/enabledDECSr',
          'data': this.input,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(result => {
          if (result.data.code == 200) {
            this.srListLoader = false;
            this.listUserData = [];
            this.getSRUserList();
            this.$alertify.success(result.data.message);
            this.resetForm();
          } else {
            this.srListLoader = false;
            this.listUserData = [];
            this.getSRUserList();
            this.$alertify.error(result.data.error)
            this.resetForm();
          }
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.userid = '';
      this.hubid = '';
      this.selectedHubObj = '';
      this.selectedUserObj = '';
      this.comment = '';
      this.$validator.reset();
      this.errors.clear();
      this.getSRUserList();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.enabledAllocation(event);
        }
      }).catch(() => {
        console.log('errors exist', JSON.stringify(this.errors))
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/decenableallocation/decenableallocation.component.js